import { render, staticRenderFns } from "./TravelHistory.vue?vue&type=template&id=cb6aa6f4&scoped=true"
import script from "./TravelHistory.vue?vue&type=script&lang=js"
export * from "./TravelHistory.vue?vue&type=script&lang=js"
import style0 from "./TravelHistory.vue?vue&type=style&index=0&id=cb6aa6f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6aa6f4",
  null
  
)

export default component.exports